/* XION Attribution Tracking + getBookingUrl() + Book-a-Call wiring + PDP link interceptor + floating call widget
   Ported from Inergize lead stack. localStorage prefix: xion_  (DO NOT change — GHL custom fields mirror these keys). */
(function(){
  var p = new URLSearchParams(window.location.search);
  var prefix = 'xion_';
  ['gclid','gbraid','wbraid','fbclid'].forEach(function(k){
    var v = p.get(k);
    if(v){
      localStorage.setItem(prefix + k, v);
      sessionStorage.setItem(prefix + k, v);
      document.cookie = prefix + k + '=' + v + ';max-age=7776000;path=/;SameSite=Lax';
    }
  });
  ['utm_source','utm_medium','utm_campaign','utm_content','utm_term','utm_placement'].forEach(function(k){
    var v = p.get(k);
    if(v){
      localStorage.setItem(prefix + k, v);
      sessionStorage.setItem(prefix + k, v);
      document.cookie = prefix + k + '=' + v + ';max-age=7776000;path=/;SameSite=Lax';
    }
  });
  if(!localStorage.getItem(prefix + 'landing_page')){
    localStorage.setItem(prefix + 'landing_page', window.location.href);
    localStorage.setItem(prefix + 'referrer', document.referrer || '');
    localStorage.setItem(prefix + 'first_touch_ts', new Date().toISOString());
  }
  localStorage.setItem(prefix + 'latest_touch_ts', new Date().toISOString());

  /* Sync UTMs to Shopify cart note_attributes so abandoned checkout webhooks carry attribution */
  function syncToCart() {
    var attrs = {};
    var keys = ['gclid','gbraid','wbraid','fbclid','utm_source','utm_medium','utm_campaign','utm_content','utm_term','utm_placement','landing_page','referrer','first_touch_ts','latest_touch_ts'];
    var hasAny = false;
    keys.forEach(function(k) {
      var v = localStorage.getItem(prefix + k);
      if (v) { attrs[k] = v; hasAny = true; }
    });
    if (hasAny) {
      fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ attributes: attrs })
      }).catch(function(){});
    }
  }
  syncToCart();
})();

/* Global getBookingUrl() — appends all attribution params to XION's GHL booking link */
function getBookingUrl(bookingAsset) {
  var base = 'https://api.leadconnectorhq.com/widget/bookings/xion-23d03d4f-0584-4fcd-a9d2-278c31a257bc';
  var prefix = 'xion_';
  // Detect product interest from current page (generic: use the product title)
  var productInterest = '';
  if (window.meta && window.meta.product) {
    productInterest = window.meta.product.title || '';
  }
  var params = new URLSearchParams({
    utm_source: localStorage.getItem(prefix + 'utm_source') || '',
    utm_medium: localStorage.getItem(prefix + 'utm_medium') || '',
    utm_campaign: localStorage.getItem(prefix + 'utm_campaign') || '',
    utm_content: localStorage.getItem(prefix + 'utm_content') || '',
    utm_term: localStorage.getItem(prefix + 'utm_term') || '',
    utm_placement: localStorage.getItem(prefix + 'utm_placement') || '',
    gclid: localStorage.getItem(prefix + 'gclid') || '',
    gbraid: localStorage.getItem(prefix + 'gbraid') || '',
    wbraid: localStorage.getItem(prefix + 'wbraid') || '',
    fbclid: localStorage.getItem(prefix + 'fbclid') || '',
    booking_asset: bookingAsset || '',
    product_interest: productInterest,
    landing_page: localStorage.getItem(prefix + 'landing_page') || '',
    referrer: localStorage.getItem(prefix + 'referrer') || '',
    first_touch_ts: localStorage.getItem(prefix + 'first_touch_ts') || '',
    latest_touch_ts: new Date().toISOString(),
    source_form: 'booking_form',
    form_page: window.location.href
  });
  return base + '?' + params.toString();
}

/* Book-a-Call wiring — any element with [data-book-call] opens the booking widget in a new tab.
   Optional [data-booking-asset="..."] labels the source (defaults to "header"). */
(function(){
  function handler(e) {
    var el = e.target.closest('[data-book-call]');
    if (!el) return;
    e.preventDefault();
    window.open(getBookingUrl(el.getAttribute('data-booking-asset') || 'header'), '_blank');
  }
  document.addEventListener('click', handler);
  document.addEventListener('keydown', function(e){
    if ((e.key === 'Enter' || e.key === ' ') && e.target.closest('[data-book-call]')) handler(e);
  });
})();

/* PDP Link Interceptor — catches clicks on direct GHL booking links and routes through getBookingUrl() */
document.addEventListener('click', function(e) {
  var link = e.target.closest('a');
  if (!link) return;
  var href = link.getAttribute('href') || '';
  if (href.indexOf('api.leadconnectorhq.com/widget/bookings') !== -1) {
    e.preventDefault();
    var asset = 'pdp_' + (window.meta && window.meta.product ? window.meta.product.handle : 'unknown');
    if (link.closest('.site-footer, footer, .footer')) asset = 'footer_cta';
    if (link.closest('.announcement-bar, .toolbar')) asset = 'announcement_bar';
    window.open(getBookingUrl(asset), '_blank');
  }
}, true);

/* Floating Call Widget — DISABLED for now. Set ENABLE_CALL_WIDGET = true to activate. */
(function(){
  function createCallWidget() {
    if (window.location.pathname.indexOf('thank-you') !== -1) return;
    if (window.location.pathname.indexOf('checkout') !== -1) return;

    var style = document.createElement('style');
    style.textContent = [
      '@keyframes xion-pulse-cycle {',
      '  0% { transform: scale(1); }',
      '  2.78% { transform: scale(1.08); }',
      '  5.56% { transform: scale(1); }',
      '  8.33% { transform: scale(1.08); }',
      '  11.11% { transform: scale(1); }',
      '  13.89% { transform: scale(1.08); }',
      '  16.67% { transform: scale(1); }',
      '  100% { transform: scale(1); }',
      '}',
      '#xion-call-widget {',
      '  position: fixed; bottom: 118px; right: 30px; z-index: 999998;',
      '  width: 60px; height: 60px; border-radius: 50%;',
      '  background: #0F172A; display: flex; align-items: center; justify-content: center;',
      '  cursor: pointer; box-shadow: 0 2px 4px rgba(15,23,42,0.16);',
      '  transition: box-shadow 0.2s; animation: xion-pulse-cycle 36s ease-in-out infinite;',
      '}',
      '#xion-call-widget:hover { box-shadow: 0 4px 10px rgba(15,23,42,0.3); }',
      '#xion-call-widget svg { width: 24px; height: 24px; fill: #ffffff; }'
    ].join('\n');
    document.head.appendChild(style);

    var widget = document.createElement('div');
    widget.id = 'xion-call-widget';
    widget.setAttribute('aria-label', 'Book a Call');
    widget.setAttribute('role', 'button');
    widget.setAttribute('tabindex', '0');
    widget.setAttribute('data-book-call', '');
    widget.setAttribute('data-booking-asset', 'website_call_widget');
    widget.innerHTML = '<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="M20.01 15.38c-1.23 0-2.42-.2-3.53-.56a.977.977 0 00-1.01.24l-1.57 1.97c-2.83-1.35-5.48-3.9-6.89-6.83l1.95-1.66c.27-.28.35-.67.24-1.02-.37-1.11-.56-2.3-.56-3.53 0-.54-.45-.99-.99-.99H4.19C3.65 3 3 3.24 3 3.99 3 13.28 10.73 21 20.01 21c.71 0 .99-.63.99-1.18v-3.45c0-.54-.45-.99-.99-.99z"/></svg>';
    document.body.appendChild(widget);
  }

  var ENABLE_CALL_WIDGET = false;
  if (ENABLE_CALL_WIDGET) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', createCallWidget);
    } else {
      createCallWidget();
    }
  }
})();

/* Gorgias Chat UTM Injection — re-adds UTMs to the URL so chat meta.current_page always carries them */
(function(){
  var prefix = 'xion_';
  if (window.location.search.indexOf('utm_source') !== -1) return;

  var utmSource = localStorage.getItem(prefix + 'utm_source');
  if (!utmSource) return;

  var utmKeys = ['utm_source','utm_medium','utm_campaign','utm_content','utm_term','gclid','gbraid','fbclid'];
  var params = new URLSearchParams(window.location.search);
  utmKeys.forEach(function(k) {
    var v = localStorage.getItem(prefix + k);
    if (v && !params.has(k)) params.set(k, v);
  });

  try {
    var newUrl = window.location.pathname + '?' + params.toString() + window.location.hash;
    history.replaceState(null, '', newUrl);
  } catch(e) {}
})();
